import { render, staticRenderFns } from "./PaymentMethodsReportList.vue?vue&type=template&id=08cc8f36&"
import script from "./PaymentMethodsReportList.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodsReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports